import styled from 'styled-components';

export const ASRListItemDetails = styled.div<any>`
  font-size: 16px;
  line-height: 20px;
  padding: 8px 16px;
  color: var(--cvna-color-blue-6);
  display: flex;
  flex-direction: column;
  white-space: pre-line;

  span {
    font-weight: 700;
  }

  > div {
    margin-bottom: 16px;
    overflow: hidden;
    word-break: break-word;
  }

  ul {
    padding-left: 20px;
  }
`;

export const Image = styled.img<any>`
  max-width: 100%;
  margin: 16px;
  height: 80px;
`;
